import { useState } from 'react';

import { EventKey, dispatchEvent } from '@tgg/services';
import { palette } from '@tgg/ui';
import { encodeAsBase64 } from '@tgg/util';

import {
    StyledTitleContainer,
    StyledTitle,
    StyledIcon,
    StyledIconContainer,
    StyledContent,
} from './SmallExpander.styled';
import { ExpanderProperties } from './SmallExpander.types';

export const SmallExpander = ({ title, children }: ExpanderProperties) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const uniqueId = `expander-${encodeAsBase64(title).slice(0, 10)}`;

    return (
        <>
            <StyledTitleContainer
                onClick={(event: any) => {
                    event.stopPropagation();
                    setIsExpanded(!isExpanded);

                    void dispatchEvent(EventKey.ACCORDION_CLICK_MBT, {
                        accordion_content: title,
                    });
                }}
            >
                <StyledTitle id={uniqueId}>{title}</StyledTitle>
                <StyledIconContainer $expanded={isExpanded}>
                    <StyledIcon
                        name="smallChevron"
                        size={16}
                        color={palette.common.blue}
                    />
                </StyledIconContainer>
            </StyledTitleContainer>
            <StyledContent
                data-testid={'small-expander-content'}
                $expanded={isExpanded}
                aria-expanded={isExpanded}
                aria-labelledby={uniqueId}
            >
                {children}
            </StyledContent>
        </>
    );
};
